import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';
import _ from 'lodash';
import mergeStates from '../../helpers/mergeStates';
import classes from './FormContactDetail.scss';
import IconDelete from 'material-ui/svg-icons/action/delete';

const communicationTypes = require('../../locales/contactDetails/de');

const communicationTypesOptions = [];
_.forOwn(communicationTypes, (label, value) => {
  // create new object that will be handled by griddle
  communicationTypesOptions.push({
    value,
    label,
  });
});

class FormContactDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.contactDetail;
  }

  handleChange = e => {
    const nextState = mergeStates(e, this.state);
    // // console.log(nextState);
    this.setState(nextState);
    this.props.onChange(nextState);
  };

  selectCommunicationType = val => {
    if (__DEV__) {
      // console.log('selected', val);
    }

    const order = ['email', 'mobile', 'tel', 'fax', 'web', 'other'];

    const nextState = this.state;

    if (val === null) {
      nextState.type = null;
    } else {
      nextState.type = val.value;
      nextState.orderByType = order.indexOf(val.value);
    }

    this.setState(nextState);
    this.props.onChange(nextState);
  };

  handleDelete = e => {
    this.props.onDelete(this.state);
  };

  render() {
    // const props = this.props
    return (
      <div className={classes.form}>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="street">
              Kommunikationsart
            </label>
          </div>
          <div className="col-xs-12 col-sm-3">
            <Select
              name="type"
              value={this.state.type}
              options={communicationTypesOptions}
              onChange={this.selectCommunicationType}
              placeholder="Kommunikationsart wählen"
              clearable={false}
            />
          </div>
          <div className="col-xs-12 col-sm-2" />
          <div className="col-xs-12 col-sm-3 text-right">
            <span
              className={classes.formButton}
              onMouseDown={e => this.handleDelete(e)}
            >
              <IconDelete /> Entfernen
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="value">
              Nummer
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <input
              name="value"
              value={this.state.value}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="note">
              Notiz (optional)
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <input
              name="note"
              value={this.state.note}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>
      </div>
    );
  }
}
FormContactDetail.propTypes = {
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  contactDetail: PropTypes.object.isRequired,
};
export default FormContactDetail;



// WEBPACK FOOTER //
// ./src/components/FormContactDetail/FormContactDetail.js